import config from '../config';
import selectedEnvironment from '../env';

const API_URL = config[selectedEnvironment].API_URL;

const authHeaders = (token) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

const HasSelfInvoices = async (caseId, token) => {
  const response = await fetch(`${API_URL}/SelfIncomes/HasSelfInvoices/${encodeURIComponent(caseId)}`, {
    method: 'GET',
    headers: authHeaders(token),
  });
  if (!response.ok) throw new Error('Failed to check self invoices');
  return response.json();
};

const GetSelfInvoicesByDateRange = async (caseId, date, endDate, token) => {
  const response = await fetch(`${API_URL}/SelfIncomes/byDateRange`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({
      caseId,
      date,
      endDate,
    }),
  });
  if (!response.ok) throw new Error('Failed to load self invoices');
  return response.json();
};

const ExportSelfInvoiceReportPdf = async (caseId, date, endDate, token) => {
  const response = await fetch(`${API_URL}/SelfIncomes/ExportReport/pdf`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({
      caseId,
      date,
      endDate,
    }),
  });
  if (!response.ok) throw new Error('Failed to export self invoice report');
  return response.blob();
};

const SendSelfInvoiceEmail = async (payload, token) => {
  const response = await fetch(`${API_URL}/SelfIncomes/SendEmail`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Failed to send email');
  }
  return response.json();
};

const SendSelfInvoiceWhatsApp = async (payload, token) => {
  const response = await fetch(`${API_URL}/SelfIncomes/SendWhatsApp`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Failed to send WhatsApp');
  }
  return response.json();
};

const SelfIncomesService = {
  HasSelfInvoices,
  GetSelfInvoicesByDateRange,
  ExportSelfInvoiceReportPdf,
  SendSelfInvoiceEmail,
  SendSelfInvoiceWhatsApp,
};

export default SelfIncomesService;
